import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { style: {"float":"left","padding-left":"5px","padding-bottom":"5px","padding-top":"3px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_4 = ["src"]

import {reactive, onMounted, onUnmounted,computed,watch} from 'vue';
import {ButtonInfo,SearchInput} from '../Entity/pageButtonInfo';
import {ElMessage } from 'element-plus';
import $http from '../http/index';
import $helper from '@/helper/helper';

// 入参
interface ImageInfo {
    name:string,
    value:any,  // 图片值
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SizeSearch',
  props: {
    isShowInput: { type: Boolean }
  },
  emits: ['showSizeSearchData','searching','searched'],
  setup(__props: any, { emit }) {

const props = __props as {
    isShowInput:boolean
};





let intervalResult = -1;
onMounted(()=>{
    intervalResult = window.setInterval(()=>{
        data.windowWidthAndHeight = window.innerWidth+"-"+window.innerHeight;
    },500)
    const brandDecoration = $helper.getBrandDecoration();
    if(brandDecoration.BrandInputColor){
        data.checkProductTypeCheckStyle=`background-color:#${brandDecoration.BrandInputColor}`
    }
    //产品类别
    if(brandDecoration.ProductTypes){
        const types = brandDecoration.ProductTypes.split(',')
        const showProductTypes:Array<ButtonInfo> =[];
        for(let i=0;i<data.productTypes.length;i++){
        const index = types.findIndex(c=>c==data.productTypes[i].code);
        if(index>-1){
            showProductTypes.push(data.productTypes[i])
        }
        }
        data.productTypes = showProductTypes;
    }
})

onUnmounted(()=>{
    if(intervalResult!=-1){
        window.clearInterval(intervalResult);
    }
})

class InitData{
    productTypes: Array<ButtonInfo> = [
        { type: '', text: '刹车片', code: "BrakePads", icon: '' , isShow: true},
        { type: '', text: '刹车蹄', code: "BrakeShoe", icon: '' , isShow: true},
        { type: '', text: '报警线', code: "WarnLine", icon: '' , isShow: true},
        { type: '', text: '刹车盘', code: "BrakeDisc", icon: '' , isShow: true},
        { type: '', text: '刹车鼓', code: "BrakeDrum", icon: '' , isShow: true}
    ]
    searchInputs:Array<SearchInput>=[
        { type: '', text: '长', code: "Length", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '宽', code: "Width", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '摩擦块宽', code: "FrictionBlock", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '厚', code: "Thickness", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '外径', code: "Diameter", icon: '',inputValue:'',classify:'BrakeShoe' },
        { type: '', text: '宽', code: "Width", icon: '',inputValue:'',classify:'BrakeShoe' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakeShoe' },
        { type: '', text: '长度1', code: "Length_1", icon: '',inputValue:'',classify:'WarnLine' },
        { type: '', text: '长度2', code: "Length_2", icon: '',inputValue:'',classify:'WarnLine' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'WarnLine' },
        { type: '', text: '直径', code: "Diameter", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '盘厚', code: "Thickness", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '高度', code: "Height", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '中间孔直径', code: "HoleCircle", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '孔数', code: "HolesNum", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '节圆直径', code: "PitchCircle", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '外直径', code: "Diameter", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '内直径', code: "InnerDiamete", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '总高', code: "Height", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '内高', code: "InnerHeight", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '中间孔直径', code: "HoleCircle", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '孔数', code: "HolesNum", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '节圆直径', code: "PitchCircle", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakeDrum' },
    ]
    checkProductType='BrakePads'
    imageInfoes:Array<ImageInfo>=[
        {name:'BrakePadsCN',value:require('../assets/images/BrakePadsCN.png')},
        {name:'BrakePadsEN',value:require('../assets/images/BrakePadsEN.png')},
        {name:'BrakeShoeCN',value:require('../assets/images/BrakeShoeCN.png')},
        {name:'BrakeShoeEN',value:require('../assets/images/BrakeShoeEN.png')},
        {name:'BrakeDiscCN',value:require('../assets/images/BrakeDiscCN.png')},
        {name:'BrakeDiscEN',value:require('../assets/images/BrakeDiscEN.png')},
        {name:'BrakeDrumCN',value:require('../assets/images/BrakeDrumCN.png')},
        {name:'BrakeDrumEN',value:require('../assets/images/BrakeDrumEN.png')},
    ]
    warpStyle={
        left: '150px',
        top:'115px',
    }
    windowWidthAndHeight='' //窗口的宽高
    checkProductTypeCheckStyle="background-color:#F00"
}

const data = reactive(new InitData());

/**
 * 设置整个显示层的位置
 */
const setSite=()=>{
    let left = (window.innerWidth-1200)/2+5;
    if(left<5){
        left=55;
    }
    let leftStr = `${left}px`;
    if(leftStr!=data.warpStyle.left){
        data.warpStyle.left = `${left}px`;
    }
}

/**
 * 通过监听isShowInput值，计算设置整个显示层的位置。
 */
watch(()=>props.isShowInput,()=>{
    setSite();
    let sizeSearchInputsStr = window.sessionStorage.getItem("sizeSearchInputs");
    if(sizeSearchInputsStr){
        data.searchInputs = JSON.parse(sizeSearchInputsStr)
    }
})

watch(()=>data.windowWidthAndHeight,()=>{
    data.warpStyle.left = `5px`;
    setSite();
})

const checkProductTypeEvent = (code:string)=>{
    data.checkProductType = code;
}

/**
 * 当前的查询的产品类型
 */
const currentProductType = computed(()=>{
    let index = data.productTypes.findIndex(c=>c.code ==data.checkProductType);
    if(index<0)return null;
    return data.productTypes[index];
})

/**
 * 当前查询输入项
 */
const currentSearchInputs = computed(()=>{
    return data.searchInputs.filter(c=>c.classify ==data.checkProductType)
})

/**
 * 重置查询条件
 */
const resetSearchCondition = ()=>{
    for(let index =0 ; index < data.searchInputs.length ; index++){
        if(data.searchInputs[index].classify ==data.checkProductType){
            data.searchInputs[index].inputValue = '';
        }
    }
    window.sessionStorage.setItem("sizeSearchInputs",JSON.stringify(data.searchInputs));
}

/**
 * 参考图示
 */
const ReferenceDiagram = computed(()=>{
    // 目前只显示中文图示
    let imageName = `${data.checkProductType}CN`;
    if(window.localStorage.getItem('lanType')=="EN"){
        imageName = `${data.checkProductType}EN`;
    }
    let index = data.imageInfoes.findIndex(c=>c.name ==imageName);
    if(index<0){
        return '';
    }
    return data.imageInfoes[index].value
})

/**
 * 查询操作
 */
const search = () =>{
    let isInputSearchConditon = false; //是否输入查询条件
    let serchParam:Array<SearchInput> = [];
    for(let index =0 ; index < data.searchInputs.length ; index++){
        if(data.searchInputs[index].classify ==data.checkProductType){
            serchParam.push(data.searchInputs[index]);
            if(data.searchInputs[index].inputValue &&data.searchInputs[index].code!="Offset"){
                isInputSearchConditon=true;
            }
        }
    }
    if(isInputSearchConditon==false){
        ElMessage({
            message: '先输入尺寸信息',
            type: 'warning',
        })
        return;
    }
    emit("searching")
    $http({
        url: "/API/Product/ProductBySizeSearch",
        method: "POST",
        data: {
            searchInput: JSON.stringify(serchParam),
        }
    }).then(res => {
        if(res.data.length<1){
            ElMessage({
                message: $helper.lan('暂无数据提供'),
                type: 'warning',
            })
        }
        for(let i=0;i<res.data.length;i++){
            res.data[i].MapCode = ''
        }
        window.sessionStorage.setItem("sizeSearchInputs",JSON.stringify(data.searchInputs));
        emit("showSizeSearchData",JSON.stringify(res.data),data.checkProductType)
        emit("searched")
    }).finally(()=>{
        emit("searched")
    })
}

/**
 * 查询输入框样式
 * @param classify 
 */
const inputStyle=(classify:string)=>{
    if(classify=="BrakePads" ||classify=="BrakeShoe"||classify=="WarnLine"){
        return {
            'width': '100px',
            'margin-right': '5px'
        }
    }
    if(classify=="BrakeDisc" ){
        return {
            'width': '85px',
            'margin-right': '5px'
        }
    }
    return {
        'width': '70px',
        'margin-right': '5px'
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "warpStyle",
    style: _normalizeStyle(data.warpStyle)
  }, [
    _createVNode(_component_el_row, { style: {"margin-bottom":"5px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          style: {"padding-left":"5px","padding-bottom":"5px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref($helper).lan(_unref(currentProductType)?.text)) + " " + _toDisplayString(_unref($helper).lan('按尺寸查询，请输入关键信息(mm)')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 24-8-data.productTypes.length*2
        }, null, 8, ["span"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.productTypes, (productType) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            span: 2,
            key: productType.code
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle(data.checkProductType == productType.code ? data.checkProductTypeCheckStyle : ''),
                onClick: ($event: any) => (checkProductTypeEvent(productType.code))
              }, [
                _createElementVNode("div", {
                  class: "checkSearchClassify",
                  style: _normalizeStyle(data.checkProductType == productType.code ? 'color:#CCC' : '')
                }, _toDisplayString(_unref($helper).lan(productType.text)), 5)
              ], 12, _hoisted_1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentSearchInputs), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"float":"left","padding-left":"5px","padding-bottom":"5px"},
                key: item.code
              }, [
                _createVNode(_component_el_text, {
                  class: "mx-1",
                  style: {"font-weight":"600"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($helper).lan(item.text)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createTextVNode("  "),
                _createVNode(_component_el_input, {
                  type: "number",
                  style: _normalizeStyle(inputStyle(item.classify)),
                  modelValue: item.inputValue,
                  "onUpdate:modelValue": ($event: any) => ((item.inputValue) = $event),
                  placeholder: _unref($helper).lan('输入')
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "placeholder"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode("   "),
              _createVNode(_component_el_link, {
                underline: false,
                onClick: search
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_unref($helper).lan('查询')), 1)
                ]),
                _: 1
              }),
              _createTextVNode("   "),
              _createVNode(_component_el_link, {
                underline: false,
                onClick: resetSearchCondition
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_unref($helper).lan('重置')), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(ReferenceDiagram))
      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              style: {"padding-left":"5px","padding-bottom":"5px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($helper).lan(_unref(currentProductType)?.text)) + " " + _toDisplayString(_unref($helper).lan('图示')) + "：", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 24,
              style: {"padding-left":"5px","padding-bottom":"5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(ReferenceDiagram),
                  style: {"max-width":"800px","max-height":"300px"}
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 4)), [
    [_vShow, props.isShowInput]
  ])
}
}

})